module.exports = __webpack_public_path__ + "img/gas-safe-logo.94f338bc.png";